import React from 'react'
import './Header.scss'
import { Link } from 'react-router-dom'
import { routerTreePathConfig } from '@/routeTree'
import { Modal } from 'antd'
import { IMG_ORIGINAL, SALE_HOTLINE, CONSUMER_HOTLINE } from '@utils/constant'

const PRODUCT_PATHS = [
  routerTreePathConfig.SSCMP,
  routerTreePathConfig.SHS,
  routerTreePathConfig.POSS,
  routerTreePathConfig.PHMS,
  routerTreePathConfig.HSMIP,
  routerTreePathConfig.SPD,
]

const MOBILE_PRODUCT_MENU = [
  {
    title: '药械SPD数字化与服务',
    items: [
      { label: '智慧供应链SPD管理平台', path: routerTreePathConfig.SSCMP },
      { label: '智能硬件解决方案', path: routerTreePathConfig.SHS },
      { label: '专业化运营服务体系', path: routerTreePathConfig.POSS },
    ],
  },
  {
    title: '患者健康管理服务',
    items: [
      { label: '诊前—陪诊服务', path: routerTreePathConfig.PHMS },
      { label: '诊中—陪护服务', path: routerTreePathConfig.PHMS },
      { label: '诊后—康护管理', path: routerTreePathConfig.PHMS },
    ],
  },
  {
    title: '医院智慧管理一体化',
    items: [{ label: '医院智慧管理一体化平台', path: routerTreePathConfig.HSMIP }],
  },
]

const MOBILE_NAV_ITEMS = [
  { key: 'home', label: '官网首页', path: routerTreePathConfig.Home },
  { key: 'product', label: '产品服务', isProduct: true },
  { key: 'partners', label: '生态伙伴', path: routerTreePathConfig.UserScenarios },
  { key: 'news', label: '新闻中心', path: routerTreePathConfig.News },
  { key: 'about', label: '关于我们', path: routerTreePathConfig.About },
  { key: 'jobs', label: '人才招聘', path: routerTreePathConfig.StaffHired },
]

class Header extends React.Component {
  state = {
    visible: false,
    isShowProductList: false,
    menuOpen: false,
  }

  componentDidMount() {
    this.onResize = () => {
      if (!this.isMobile() && this.state.menuOpen) {
        this.closeMenu()
      }
    }
    window.addEventListener('resize', this.onResize)
  }

  componentWillUnmount() {
    document.body.style.overflow = ''
    window.removeEventListener('resize', this.onResize)
  }

  isMobile = () => window.innerWidth <= 768

  closeMenu = () => {
    this.setState({ menuOpen: false, isShowProductList: false })
    document.body.style.overflow = ''
  }

  openMenu = () => {
    const isProductPage = PRODUCT_PATHS.includes(this.props.appProps.location.pathname)
    this.setState(
      {
        menuOpen: true,
        isShowProductList: isProductPage,
      },
      () => {
        document.body.style.overflow = 'hidden'
      },
    )
  }

  toggleMenu = () => {
    if (this.state.menuOpen) {
      this.closeMenu()
    } else {
      this.openMenu()
    }
  }

  toggleMobileProduct = e => {
    e.preventDefault()
    this.setState(prev => ({ isShowProductList: !prev.isShowProductList }))
  }

  onGoproduct(path) {
    const { history } = this.props.appProps
    this.closeMenu()
    history.push(path)
    location.reload()
  }

  isNavActive = (item, pathname) => {
    if (item.isProduct) {
      return PRODUCT_PATHS.includes(pathname)
    }
    if (item.key === 'news') {
      return [routerTreePathConfig.News, routerTreePathConfig.NewsDetail].includes(pathname)
    }
    return pathname === item.path
  }

  renderDesktopProductNav() {
    return (
      <div
        ref='productNav'
        className='product-nav'
        onMouseLeave={() => {
          if (!this.isMobile()) {
            this.setState({ isShowProductList: false })
          }
        }}
      >
        <div className='product-content'>
          <div className='left'>
            <div className='title'>药械SPD数字化与服务</div>
            <div className='nav'>
              <div className='nav-item' onClick={() => this.onGoproduct(routerTreePathConfig.SSCMP)}>
                <img src={`${IMG_ORIGINAL}/home-icon98.png`} alt='' />
                <div className='nav-title'>智慧供应链SPD管理平台</div>
              </div>
              <div className='nav-item' onClick={() => this.onGoproduct(routerTreePathConfig.SHS)}>
                <img src={`${IMG_ORIGINAL}/home-icon98.png`} alt='' />
                <div className='nav-title'>智能硬件解决方案</div>
              </div>
              <div className='nav-item' onClick={() => this.onGoproduct(routerTreePathConfig.POSS)}>
                <img src={`${IMG_ORIGINAL}/home-icon98.png`} alt='' />
                <div className='nav-title'>专业化运营服务体系</div>
              </div>
            </div>
          </div>
          <div className='split'></div>
          <div className='middle'>
            <div className='title'>患者健康管理服务</div>
            <div className='nav'>
              <div className='nav-item' onClick={() => this.onGoproduct(routerTreePathConfig.PHMS)}>
                <img src={`${IMG_ORIGINAL}/home-icon98.png`} alt='' />
                <div className='nav-title'>诊前—陪诊服务</div>
              </div>
              <div className='nav-item' onClick={() => this.onGoproduct(routerTreePathConfig.PHMS)}>
                <img src={`${IMG_ORIGINAL}/home-icon98.png`} alt='' />
                <div className='nav-title'>诊中—陪护服务</div>
              </div>
              <div className='nav-item' onClick={() => this.onGoproduct(routerTreePathConfig.PHMS)}>
                <img src={`${IMG_ORIGINAL}/home-icon98.png`} alt='' />
                <div className='nav-title'>诊后—康护管理</div>
              </div>
            </div>
          </div>
          <div className='split'></div>
          <div className='right'>
            <div className='title'>医院智慧管理一体化</div>
            <div className='nav'>
              <div className='nav-item' onClick={() => this.onGoproduct(routerTreePathConfig.HSMIP)}>
                <img src={`${IMG_ORIGINAL}/home-icon98.png`} alt='' />
                <div className='nav-title'>医院智慧管理一体化平台</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderMobileDrawer(pathname, history) {
    const { menuOpen, isShowProductList } = this.state
    if (!menuOpen) return null

    return (
      <div className='mobile-drawer'>
        <div className='mobile-drawer-mask' onClick={this.closeMenu} />
        <button type='button' className='mobile-drawer-close' aria-label='关闭菜单' onClick={this.closeMenu} />
        <div className={`mobile-drawer-panel${isShowProductList ? ' mobile-drawer-panel-expanded' : ''}`}>
          <div className='mobile-drawer-sidebar'>
            <div className='mobile-drawer-nav'>
              {MOBILE_NAV_ITEMS.map(item => {
                const active = this.isNavActive(item, pathname)
                if (item.isProduct) {
                  return (
                    <a
                      key={item.key}
                      href='#product'
                      className={`mobile-drawer-nav-item${active ? ' is-active' : ''}${isShowProductList ? ' is-expanded' : ''}`}
                      onClick={this.toggleMobileProduct}
                    >
                      <span>{item.label}</span>
                      <i className='mobile-drawer-chevron' />
                    </a>
                  )
                }
                return (
                  <Link
                    key={item.key}
                    to={item.path}
                    className={`mobile-drawer-nav-item${active ? ' is-active' : ''}`}
                    onClick={this.closeMenu}
                  >
                    <span>{item.label}</span>
                  </Link>
                )
              })}
            </div>
            <div className='mobile-drawer-footer'>
              <div className='mobile-drawer-actions'>
                <div
                  className='mobile-drawer-btn mobile-drawer-btn-primary'
                  onClick={() => {
                    this.closeMenu()
                    history.push(routerTreePathConfig.FreeTrial)
                  }}
                >
                  免费试用
                </div>
                <div
                  className='mobile-drawer-btn mobile-drawer-btn-outline'
                  onClick={() => {
                    this.closeMenu()
                    this.setState({ visible: true })
                  }}
                >
                  立即登录
                </div>
              </div>
              <div className='mobile-drawer-hotline'>
                <div>销售热线：</div>
                <div>{SALE_HOTLINE}</div>
              </div>
            </div>
          </div>
          {isShowProductList && (
            <div className='mobile-drawer-sub'>
              {MOBILE_PRODUCT_MENU.map(group => (
                <div key={group.title} className='mobile-drawer-sub-group'>
                  <div className='mobile-drawer-sub-title'>{group.title}</div>
                  {group.items.map(subItem => (
                    <div
                      key={subItem.label}
                      className={`mobile-drawer-sub-item${pathname === subItem.path ? ' is-active' : ''}`}
                      onClick={() => this.onGoproduct(subItem.path)}
                    >
                      {subItem.label}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    )
  }

  render() {
    const {
      location: { pathname },
      history,
    } = this.props.appProps
    const isProductActive = PRODUCT_PATHS.includes(pathname)

    return (
      <div className={this.state.menuOpen ? 'header is-menu-open' : 'header'}>
        <div className='header-content'>
          <div
            className='logo-title'
            onClick={() => {
              this.closeMenu()
              history.push(routerTreePathConfig.Home)
            }}
          >
            <img src={`${IMG_ORIGINAL}/home-ebeiLogo.png`} alt='' />
          </div>
          <div className='header-nav'>
            <Link
              to={routerTreePathConfig.Home}
              className={pathname === routerTreePathConfig.Home ? 'link link-active' : 'link'}
            >
              官网首页
            </Link>
            <Link
              to={routerTreePathConfig.SPD}
              className={isProductActive ? 'link link-active product-link' : 'link product-link'}
              onMouseMove={() => {
                if (!this.isMobile()) {
                  this.setState({ isShowProductList: true })
                }
              }}
            >
              产品服务<i className={isProductActive ? 'arrow arrow-active' : 'arrow'}></i>
            </Link>
            <Link
              to={routerTreePathConfig.UserScenarios}
              className={pathname === routerTreePathConfig.UserScenarios ? 'link link-active' : 'link'}
            >
              生态伙伴
            </Link>
            <Link
              to={routerTreePathConfig.News}
              className={
                [routerTreePathConfig.News, routerTreePathConfig.NewsDetail].includes(pathname) ? 'link link-active' : 'link'
              }
            >
              新闻中心
            </Link>
            <Link
              to={routerTreePathConfig.About}
              className={pathname === routerTreePathConfig.About ? 'link link-active' : 'link'}
            >
              关于我们
            </Link>
            <Link
              to={routerTreePathConfig.StaffHired}
              className={pathname === routerTreePathConfig.StaffHired ? 'link link-active' : 'link'}
            >
              人才招聘
            </Link>
          </div>
          {!this.isMobile() && this.state.isShowProductList && this.renderDesktopProductNav()}
          <div className='contacts'>
            <div className='action-jump'>
              <div
                className='free button'
                onClick={() => {
                  history.push(routerTreePathConfig.FreeTrial)
                }}
              >
                <span>免费试用</span>
              </div>
              <div
                className='login button'
                onClick={() => {
                  this.setState({ visible: true })
                }}
              >
                <span>立即登录</span>
              </div>
            </div>
            <div className='aek-ml20 header-hotline'>
              <div className='phone'>售前咨询：{SALE_HOTLINE}</div>
              <div className='phone'>售后服务：{CONSUMER_HOTLINE}</div>
            </div>
          </div>
          <div className='menu-toggle' onClick={this.toggleMenu}>
            <span />
            <span />
            <span />
          </div>
        </div>
        {this.renderMobileDrawer(pathname, history)}
        <Modal
          title='请选择登陆角色'
          width='500px'
          mask
          keyboard
          maskClosable
          footer={null}
          onCancel={() => {
            this.setState({ visible: false })
          }}
          visible={this.state.visible}
        >
          <div className='ui-loginTypes-box'>
            <a href='//medical.aek56.com' target='_blank' rel='noreferrer' className='loginTypes-item loginTypes-item-hospital'>
              <img src='//img.ebei99.com/ebei99-web/org-h.png' alt='' />
              我是医疗机构
            </a>
            <a href='//lobby.aek56.com' target='_blank' rel='noreferrer' className='loginTypes-item loginTypes-item-hospital'>
              <img src='//img.ebei99.com/ebei99-web/org-b.png' alt='' />
              我是企业
            </a>
          </div>
        </Modal>
      </div>
    )
  }
}

export default Header
